/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Button } from 'reactstrap';
import { QUESTION } from '../../../../constants/terminology';

export interface UseDataBtnProps {
  hasValue: boolean
  // Not yet defined what this suppose to do
  onUseData?: () => void;
  className?: string;
}

export const UseDataBtn = ({ onUseData, hasValue }: UseDataBtnProps) => {
  if (!onUseData) {
    return null;
  }

  if (hasValue) {
    return <Button color={'link'} onClick={() => onUseData()} className={''}>
        <i className={'fa-solid fa-copy mr-2'} />Use {QUESTION.SINGULAR} answer
      </Button>
  }

  return <span onClick={() => onUseData()} className={'text-ThemeTextPlaceholder'}>
      <i className={'fa-solid fa-external-link-alt mr-2'} />Copy info across
    </span>;
};
